module.exports = __webpack_public_path__ + "static/media/logo-kpw.09349b4f.png";